import * as React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Select as RSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from './@radix-styled';
import HelperText from '../HelperText';
import { cx } from 'class-variance-authority';
import { SelectProps as RSelectProps } from '@radix-ui/react-select';
import { Option } from 'types';
import clsx from 'clsx';

export type SelectVariant = 'filled' | 'transparent';

export interface SelectProps extends Omit<RSelectProps, 'onValueChange'> {
  error?: boolean;
  helperText?: string;
  label: string;
  onChange?: (value: string) => void;
  options: Option[];
  className?: string;
  placeholder?: string;
}

const Select: React.FC<SelectProps> = ({
  options,
  className,
  label,
  error,
  helperText,
  onChange,
  value,
  required,
  placeholder,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('Select flex flex-col flex-1 basis-50', className)}>
      <RSelect onValueChange={onChange} {...rest} value={value ? value : undefined}>
        <SelectTrigger
          error={error}
          className={clsx({
            ['!text-neutral-500']: !value
          })}
        >
          <SelectValue
            placeholder={placeholder ? t(placeholder) : `${t(label)} ${required ? '*' : ''}`}
          />
        </SelectTrigger>
        <SelectContent position="popper" sticky="always" alignOffset={16} sideOffset={4}>
          {options.map(option => (
            <SelectItem
              key={option.value}
              disabled={option.disabled}
              value={option.value}
              className="first:hover:rounded-t-xl last:hover:rounded-b-xl"
            >
              {t(option.label)}
            </SelectItem>
          ))}
        </SelectContent>
      </RSelect>

      {error && helperText && <HelperText error helperText={helperText} className="mt-2" />}
    </div>
  );
};

export default Select;
